export default {
  page: {
    title: 'Dividir texto en líneas',
    subtitle: 'Herramientas',
  },
  card: {
    title: 'Configuración de la división',
  },
  form: {
    options: {
      title: 'Configuración predeterminada',
      removeAccents: 'Quitar acentos',
      removeDuplicates: 'Eliminar duplicadas',
      sortAlphabetically: 'Ordenar lista',
      minWordLength: {
        label: 'Ignorar palabras con hasta:',
        unit: 'letras',
        tooltip:
          'Las palabras con cantidad de letras igual o menor que este valor serán ignoradas.',
      },
    },
    text: {
      label: 'Texto:',
    },
    result: {
      label: 'Texto generado:',
    },
    totalWords: {
      label: 'Total de palabras:',
    },
    ignored: {
      label: 'Ignoradas:',
    },
  },
  button: {
    download: 'Descargar',
  },
  alert: {
    noWordsFound:
      'No se encontró ninguna palabra con más de {count} letras.',
  },
};
